export default __webpack_public_path__ + "static/media/arrowright-fill.b14f6883.svg";